import React from "react";
import bottomLineLogoArtboard from "../images/bottom line logoArtboard 24.svg";
import clientsPageLandingLogo from "../images/clients_page_landing_logo.svg";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
import { useState, useEffect } from "react";

function Bottom() {
	const [width, setWidth] = useState(window.innerWidth);

	useEffect(() => {
		function handleWindowResize() {
			setWidth(window.innerWidth);
		}

		window.addEventListener("resize", handleWindowResize);

		return () => {
			window.removeEventListener("resize", handleWindowResize);
		};
	}, []);

	const downloadData = (e) => {
		e.preventDefault();
		axios
			.get("/download_data/", { responseType: "blob" })
			.then((response) => {
				// Create an object URL from the blob
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);

				// Create a link element to trigger the download
				const a = document.createElement("a");
				a.href = url;
				a.download = "Evidence Map - Data.xlsx"; // Set the desired file name
				document.body.appendChild(a);

				// Click the link to trigger the download
				a.click();

				// Remove the link and revoke the object URL
				document.body.removeChild(a);
				window.URL.revokeObjectURL(url);
			});
	};

	return (
		<div id="bottom">
			<div className="row" style={{ marginLeft: 0 }}>
				<div id="logo" style={{ marginRight: 10 }}>
					<a
						href="https://evidencemap.com/"
						id="copyright-link"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							id="em"
							src={clientsPageLandingLogo}
							alt="Evidence Map logo"
							className="img-fluid"
							style={{ width: 150, marginBottom: "2rem" }}
						/>
					</a>
				</div>
				<div
					id="line-wide"
					style={{
						marginTop: "0.7rem",
						width: "calc(100% - 510px)",
					}}
				>
					<hr
						style={{
							height: 1,
							backgroundColor: "#d3d3d3",
							borderTop: "none",
							marginTop: "1.3rem",
						}}
					/>
				</div>
				<div id="alma-logo-wide" style={{ marginLeft: 10 }}>
					<a
						href="https://www.almaeconomics.com/"
						id="copyright-link"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							id="alma"
							src={bottomLineLogoArtboard}
							alt="Alma Economics logo"
							className="img-fluid"
							style={{
								height: 35,
								marginBottom: width > 567 ? "-1rem" : "2rem",
							}}
						/>
					</a>
				</div>
			</div>
			{/* <div className="about-container" onClick={downloadData}>
				<DownloadIcon className="download-icon" />
				<div className="about-text text">
					Download the research extraction sheet
				</div>
			</div> */}
			<a
				className="about-container"
				href="/about"
				style={{ cursor: "pointer", width: "260px" }}
			>
				{/* <div className="notes-icon">
					<img src={clientsPageNotesIcon} alt="Report" />
				</div> 
				<div className="about-text text">Notes on methodology</div>*/}
			</a>
		</div>
	);
}

export default Bottom;
